// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* card template info start */
.kore-chat-window .card-template .card-body .card-data {
  /* border: 1px solid #85B7FE; */
  border-radius: 0 0 8px 8px;
}

.kore-chat-window .card-template .card-body .card-title {
  /* background: #E7F1FF; */
  color: #07377F;
  border-radius: 8px 8px 0px 0px;
  /* border: 1px solid #85B7FE; */
  border-bottom: 0;
}

/* card template info end */
/* card template success start */
.kore-chat-window .card-template.card-success .card-body .card-data {
  border: 1px solid #93D3A2;
}

.kore-chat-window .card-template.card-success .card-body .card-title {
  background: #EAF6EC;
  color: #135423;
  border-radius: 8px 8px 0px 0px;
  border: 1px solid #93D3A2;
  border-bottom: 0;
}

/* card template success end */
/* card template card solid info start */
/* .kore-chat-window .card-template .card-body .card-data{
    border: 1px solid #0D6EFD;
} */
.kore-chat-window .card-template .card-body .card-title {
  /* background: #0D6EFD; */
  color: #FFFFFF;
  border-radius: 8px 8px 0px 0px;
  /* border: 1px solid #0D6EFD; */
  border-bottom: 0;
}

/* card template card solid info end */
/* card template card solid full info start */
.kore-chat-window .card-template .card-body .card-title {
  font-weight: 600;
  font-size: 16px;
  line-height: 20px;
  color: #202124;
  padding: 14px 14px 8px 14px;
}

.kore-chat-window .card-template .card-body {
  background: #FFFFFF;
  color: #202124;
  border-radius: 10px;
  /* box-shadow: 4px 4px 0px rgba(19, 84, 35, 0.5); */
  border-bottom: 0;
}

/* card template card solid full info end */
/* card template card img info start */
.kore-chat-window .card-template.card-img-info .card-body {
  border: 1px solid #E4E5E7;
  box-shadow: 0px 1px 2px #bdc1c6;
  border-radius: 8px;
}

.kore-chat-window .card-template.card-img-info .card-body .card-title-block {
  display: flex;
  align-items: center;
  justify-content: flex-start;
  padding: 10px 10px 0 10px;
}

/* card template card img info end */
/* card template card img overflowmenu info start */
.kore-chat-window .card-template .card-body {
  border: 1px solid #E4E5E7;
  box-shadow: 0px 1px 2px #bdc1c6;
  border-radius: 8px;
  cursor: pointer;
}

.kore-chat-window .card-template .card-body .card-title-block {
  display: flex;
  align-items: center;
  justify-content: flex-start;
  padding: 10px 10px 0 10px;
  position: relative;
}

.kore-chat-window .card-template .card-body .card-title-block.left-border {
  padding: 10px 10px !important;
}

.kore-chat-window .card-template .card-body .card-title-block.left-border .card-block {
  border-radius: 4px !important;
}

.kore-chat-window .card-template .card-body .card-title-block .card-text-action {
  position: absolute;
  right: 10px;
  top: 10px;
}

.kore-chat-window .card-template .card-body .card-title-block .more-button-info {
  list-style: none;
  display: none;
  position: absolute;
  padding: 10px;
  right: 10px;
  min-width: 200px;
  max-height: 200px;
  box-shadow: 0px 4px 12px 2px rgba(32, 33, 36, 0.12);
  border-radius: 5px;
  background: #fff;
  height: auto;
  min-height: auto;
  z-index: 99;
}

.kore-chat-window .card-template .card-body .card-title-block .more-button-info li {
  margin: 0;
}

.kore-chat-window .card-template .card-body .card-title-block .more-button-info li .button_ {
  margin: 5px 0;
  float: right;
  border: 0;
  padding: 7px 20px;
  background: #e7f1ff;
  border-radius: 4px;
  color: #020203;
  font-weight: normal;
  font-size: 14px;
  line-height: 20px;
  cursor: pointer;
  width: 100%;
}

.kore-chat-window .card-template .card-body .card-title-block .more-button-info .close_btn {
  cursor: pointer;
  border: none;
  outline: none;
  position: static !important;
  /* top: 5px; */
  right: 22px;
  background: #fff;
  border-radius: 100%;
  padding: 0;
  width: 25px;
  height: 25px;
  text-align: center;
  z-index: 2;
  transition: 0.3s all ease;
  float: right;
}

.kore-chat-window .card-template .card-body .card-title-block .more-button-info .close_btn:hover {
  background: #DFE7F5;
}

/* .kore-chat-window .card-template .card-body .card-data{
    padding: 20px 10px;
} */
.kore-chat-window .card-template .card-body .card-data-list {
  /* display: flex; */
  align-items: center;
  justify-content: flex-start;
}

.kore-chat-window .card-template .card-body .card-data-list .card-block-text {
  padding: 0 20px 0 0;
  flex: 1;
}

.kore-chat-window .card-template .card-body .card-data-list .card-block-text .title-text {
  font-weight: 600;
  font-size: 16px;
  line-height: 20px;
  color: #202124;
}

.kore-chat-window .card-template .card-body .card-data-list .card-block-text .title-desc {
  font-weight: normal;
  font-size: 13px;
  line-height: 20px;
  color: #9AA0A6;
}

.kore-chat-window .card-template .card-body .card-data-btn.btn-info .card-btn {
  background: #0D6EFD;
  border: 1px solid #0D6EFD;
  color: #fff;
}

.kore-chat-window .card-template .card-body-info {
  width: 5px;
  height: 100%;
  background: #0D6EFD;
  position: absolute;
  border-radius: 10px;
}

.kore-chat-window .card-template .card-body .card-title-block .card-text-action .card-action-data {
  color: #BDC1C6;
  font-weight: normal;
  font-size: 12px;
  line-height: 20px;
}

.kore-chat-window .card-template .card-body .card-title-block .card-text-action .icon {
  cursor: pointer;
  margin-left: 5px;
}

/* card template card img overflowmenu info end */
/* card template card simple data info start */
.kore-chat-window .card-template.card-simple-data-info .card-body {
  border: 1px solid #E4E5E7;
  box-shadow: 0px 1px 2px #bdc1c6;
  border-radius: 8px;
}

.kore-chat-window .card-template.card-simple-data-info .card-body .card-title-block {
  display: flex;
  align-items: center;
  justify-content: flex-start;
  padding: 10px 10px;
  position: relative;
}

.kore-chat-window .card-template.card-simple-data-info .card-body .card-title-block .card-block {
  border-left: 5px solid #0d6efd;
  border-radius: 4px;
}

/* card template card simple data info end */
.kore-chat-window .card-template .card-body .card-data-btn .card-btn {
  border-radius: 0px 0px 10px 10px;
  width: 100%;
  padding: 14px 0;
  font-weight: 500;
  font-size: 14px;
  line-height: 17px;
  cursor: pointer;
}

.kore-chat-window .card-template .card-body .card-title-block .card-block {
  padding-left: 15px;
  width: calc(100% - 29px);
}

.kore-chat-window .card-template .card-body .card-title-block .card-block .title-text {
  font-weight: 600;
  font-size: 16px;
  line-height: 20px;
  color: #202124;
}

.kore-chat-window .card-template .card-body .card-title-block .card-block .title-text.card-text-overflow {
  overflow: hidden;
  text-overflow: ellipsis;
  /* width: 176px; */
  /* width: calc(100% - 190px); */
  white-space: nowrap;
  /* padding-right: 10px; */
  padding-right: 110px;
}

.kore-chat-window .card-template .card-body .card-title-block .card-block .title-desc {
  font-weight: normal;
  font-size: 13px;
  line-height: 20px;
  color: #9AA0A6;
}

.kore-chat-window .card-template .card-body .card-title-block .card-block-img {
  width: 40px;
  height: 40px;
  flex-shrink: 0;
}

.kore-chat-window .card-template .card-body .card-title-block .card-block-img .icon-text {
  width: 40px;
  height: 40px;
  vertical-align: middle;
  border-radius: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: normal;
  font-size: 12px;
  background: #0D6EFD;
  color: white;
}

.kore-chat-window .card-template .card-body .card-title-block .card-block-img.small {
  width: 16px;
  height: 16px;
}

.kore-chat-window .card-template .card-body .card-title-block .card-block-img.small img {
  width: 16px;
  height: 16px;
}

.kore-chat-window .card-template .card-body .card-title-block .card-block-img img {
  vertical-align: middle;
}

.kore-chat-window .card-template .card-body .card-title-block .card-block-img.circle-img img {
  border-radius: 100%;
}

.kore-chat-window .card-template .card-body .card-title {
  font-weight: 500;
  font-size: 14px;
  line-height: 20px;
  padding: 14px 14px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.kore-chat-window .card-template .card-data {
  padding: 10px 15px;
}

.kore-chat-window .card-template .card-data .card-data-list .card-text {
  color: #3C4043;
  font-weight: 500;
  font-size: 12px;
  line-height: 19px;
  display: flex;
  align-items: flex-start;
  position: relative;
  margin: 5px 0;
}

.kore-chat-window .card-template .card-data .card-data-list .card-text.icon {
  top: -16px;
}

.kore-chat-window .card-template .card-data .card-data-list .card-text .card-text-icon.if-icon-right .icon-img {
  width: auto;
  position: absolute;
  right: 4px;
}

.kore-chat-window .card-template .card-data .card-data-list .card-text .card-text-icon {
  width: 25px;
  padding: 5px 10px 0 0;
}

.kore-chat-window .card-template .card-data .card-data-list .card-text .card-text-icon img {
  vertical-align: middle;
}

.kore-chat-window .card-template .card-data .card-data-list .card-text .card-text-action {
  position: absolute;
  right: 0;
  transform: rotate(180deg);
}

.kore-chat-window .card-template .card-data .card-data-list.card-display-flex {
  display: flex;
}

.kore-chat-window .koreLargePreviewContent.card-template-modal {
  width: 350px !important;
}

/* card template css ends here */`, "",{"version":3,"sources":["webpack://./src/plugins/v2Plugin/templates/cardTemplate/cardTemplate.scss"],"names":[],"mappings":"AAAA,6BAAA;AAEA;EACC,+BAAA;EACA,0BAAA;AAAD;;AAGA;EACC,yBAAA;EACA,cAAA;EACA,8BAAA;EACA,+BAAA;EACA,gBAAA;AAAD;;AAIA,2BAAA;AAGA,gCAAA;AAEA;EACC,yBAAA;AAJD;;AAOA;EACC,mBAAA;EACA,cAAA;EACA,8BAAA;EACA,yBAAA;EACA,gBAAA;AAJD;;AAQA,8BAAA;AAGA,wCAAA;AAGA;;GAAA;AAIA;EACC,yBAAA;EACA,cAAA;EACA,8BAAA;EACA,+BAAA;EACA,gBAAA;AAVD;;AAcA,sCAAA;AAGA,6CAAA;AAEA;EACC,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;EACA,2BAAA;AAdD;;AAiBA;EACC,mBAAA;EACA,cAAA;EACA,mBAAA;EACA,mDAAA;EACA,gBAAA;AAdD;;AAkBA,2CAAA;AAGA,sCAAA;AAEA;EACC,yBAAA;EACA,+BAAA;EACA,kBAAA;AAlBD;;AAqBA;EACC,aAAA;EACA,mBAAA;EACA,2BAAA;EACA,yBAAA;AAlBD;;AAsBA,oCAAA;AAGA,mDAAA;AAEA;EACC,yBAAA;EACA,+BAAA;EACA,kBAAA;EACA,eAAA;AAtBD;;AAyBA;EACC,aAAA;EACA,mBAAA;EACA,2BAAA;EACA,yBAAA;EACA,kBAAA;AAtBD;;AAyBA;EACC,6BAAA;AAtBD;;AAyBA;EACC,6BAAA;AAtBD;;AAyBA;EACC,kBAAA;EACA,WAAA;EACA,SAAA;AAtBD;;AAyBA;EACC,gBAAA;EACA,aAAA;EACA,kBAAA;EACA,aAAA;EACA,WAAA;EACA,gBAAA;EACA,iBAAA;EACA,mDAAA;EACA,kBAAA;EACA,gBAAA;EACA,YAAA;EACA,gBAAA;EACA,WAAA;AAtBD;;AAyBA;EACC,SAAA;AAtBD;;AAyBA;EACC,aAAA;EACA,YAAA;EACA,SAAA;EACA,iBAAA;EACA,mBAAA;EACA,kBAAA;EACA,cAAA;EACA,mBAAA;EACA,eAAA;EACA,iBAAA;EACA,eAAA;EACA,WAAA;AAtBD;;AAyBA;EACC,eAAA;EACA,YAAA;EACA,aAAA;EACA,2BAAA;EACA,cAAA;EACA,WAAA;EACA,gBAAA;EACA,mBAAA;EACA,UAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,UAAA;EACA,yBAAA;EACA,YAAA;AAtBD;;AAyBA;EACC,mBAAA;AAtBD;;AA0BA;;GAAA;AAIA;EACC,mBAAA;EACA,mBAAA;EACA,2BAAA;AAxBD;;AA2BA;EACC,mBAAA;EACA,OAAA;AAxBD;;AA2BA;EACC,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;AAxBD;;AA2BA;EACC,mBAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;AAxBD;;AA2BA;EACC,mBAAA;EACA,yBAAA;EACA,WAAA;AAxBD;;AA2BA;EACC,UAAA;EACA,YAAA;EACA,mBAAA;EACA,kBAAA;EACA,mBAAA;AAxBD;;AA2BA;EACC,cAAA;EACA,mBAAA;EACA,eAAA;EACA,iBAAA;AAxBD;;AA2BA;EACC,eAAA;EACA,gBAAA;AAxBD;;AA4BA,iDAAA;AAGA,8CAAA;AAEA;EACC,yBAAA;EACA,+BAAA;EACA,kBAAA;AA5BD;;AA+BA;EACC,aAAA;EACA,mBAAA;EACA,2BAAA;EACA,kBAAA;EACA,kBAAA;AA5BD;;AA+BA;EACC,8BAAA;EACA,kBAAA;AA5BD;;AAgCA,4CAAA;AAEA;EACC,gCAAA;EACA,WAAA;EACA,eAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,eAAA;AA9BD;;AAiCA;EACC,kBAAA;EACA,wBAAA;AA9BD;;AAiCA;EACC,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;AA9BD;;AAiCA;EACC,gBAAA;EACA,uBAAA;EACA,kBAAA;EACA,+BAAA;EACA,mBAAA;EACA,yBAAA;EACA,oBAAA;AA9BD;;AAiCA;EACC,mBAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;AA9BD;;AAiCA;EACC,WAAA;EACA,YAAA;EACA,cAAA;AA9BD;;AAiCA;EACC,WAAA;EACA,YAAA;EACA,sBAAA;EACA,kBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,mBAAA;EACA,eAAA;EACA,mBAAA;EACA,YAAA;AA9BD;;AAiCA;EACC,WAAA;EACA,YAAA;AA9BD;;AAiCA;EACC,WAAA;EACA,YAAA;AA9BD;;AAiCA;EACC,sBAAA;AA9BD;;AAiCA;EACC,mBAAA;AA9BD;;AAiCA;EACC,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,kBAAA;EACA,gBAAA;EACA,uBAAA;EACA,mBAAA;AA9BD;;AAiCA;EACC,kBAAA;AA9BD;;AAiCA;EACC,cAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,aAAA;EACA,uBAAA;EACA,kBAAA;EACA,aAAA;AA9BD;;AAiCA;EACC,UAAA;AA9BD;;AAiCA;EACC,WAAA;EACA,kBAAA;EACA,UAAA;AA9BD;;AAiCA;EACC,WAAA;EACA,qBAAA;AA9BD;;AAiCA;EACC,sBAAA;AA9BD;;AAiCA;EACC,kBAAA;EACA,QAAA;EACA,yBAAA;AA9BD;;AAiCA;EACC,aAAA;AA9BD;;AAiCA;EACC,uBAAA;AA9BD;;AAkCA,gCAAA","sourcesContent":["/* card template info start */\n\n.kore-chat-window .card-template .card-body .card-data {\n\t/* border: 1px solid #85B7FE; */\n\tborder-radius: 0 0 8px 8px;\n}\n\n.kore-chat-window .card-template .card-body .card-title {\n\t/* background: #E7F1FF; */\n\tcolor: #07377F;\n\tborder-radius: 8px 8px 0px 0px;\n\t/* border: 1px solid #85B7FE; */\n\tborder-bottom: 0;\n}\n\n\n/* card template info end */\n\n\n/* card template success start */\n\n.kore-chat-window .card-template.card-success .card-body .card-data {\n\tborder: 1px solid #93D3A2;\n}\n\n.kore-chat-window .card-template.card-success .card-body .card-title {\n\tbackground: #EAF6EC;\n\tcolor: #135423;\n\tborder-radius: 8px 8px 0px 0px;\n\tborder: 1px solid #93D3A2;\n\tborder-bottom: 0;\n}\n\n\n/* card template success end */\n\n\n/* card template card solid info start */\n\n\n/* .kore-chat-window .card-template .card-body .card-data{\n    border: 1px solid #0D6EFD;\n} */\n\n.kore-chat-window .card-template .card-body .card-title {\n\t/* background: #0D6EFD; */\n\tcolor: #FFFFFF;\n\tborder-radius: 8px 8px 0px 0px;\n\t/* border: 1px solid #0D6EFD; */\n\tborder-bottom: 0;\n}\n\n\n/* card template card solid info end */\n\n\n/* card template card solid full info start */\n\n.kore-chat-window .card-template .card-body .card-title {\n\tfont-weight: 600;\n\tfont-size: 16px;\n\tline-height: 20px;\n\tcolor: #202124;\n\tpadding: 14px 14px 8px 14px;\n}\n\n.kore-chat-window .card-template .card-body {\n\tbackground: #FFFFFF;\n\tcolor: #202124;\n\tborder-radius: 10px;\n\t/* box-shadow: 4px 4px 0px rgba(19, 84, 35, 0.5); */\n\tborder-bottom: 0;\n}\n\n\n/* card template card solid full info end */\n\n\n/* card template card img info start */\n\n.kore-chat-window .card-template.card-img-info .card-body {\n\tborder: 1px solid #E4E5E7;\n\tbox-shadow: 0px 1px 2px #bdc1c6;\n\tborder-radius: 8px;\n}\n\n.kore-chat-window .card-template.card-img-info .card-body .card-title-block {\n\tdisplay: flex;\n\talign-items: center;\n\tjustify-content: flex-start;\n\tpadding: 10px 10px 0 10px;\n}\n\n\n/* card template card img info end */\n\n\n/* card template card img overflowmenu info start */\n\n.kore-chat-window .card-template .card-body {\n\tborder: 1px solid #E4E5E7;\n\tbox-shadow: 0px 1px 2px #bdc1c6;\n\tborder-radius: 8px;\n\tcursor: pointer;\n}\n\n.kore-chat-window .card-template .card-body .card-title-block {\n\tdisplay: flex;\n\talign-items: center;\n\tjustify-content: flex-start;\n\tpadding: 10px 10px 0 10px;\n\tposition: relative;\n}\n\n.kore-chat-window .card-template .card-body .card-title-block.left-border {\n\tpadding: 10px 10px !important;\n}\n\n.kore-chat-window .card-template .card-body .card-title-block.left-border .card-block {\n\tborder-radius: 4px !important;\n}\n\n.kore-chat-window .card-template .card-body .card-title-block .card-text-action {\n\tposition: absolute;\n\tright: 10px;\n\ttop: 10px;\n}\n\n.kore-chat-window .card-template .card-body .card-title-block .more-button-info {\n\tlist-style: none;\n\tdisplay: none;\n\tposition: absolute;\n\tpadding: 10px;\n\tright: 10px;\n\tmin-width: 200px;\n\tmax-height: 200px;\n\tbox-shadow: 0px 4px 12px 2px rgba(32, 33, 36, 0.12);\n\tborder-radius: 5px;\n\tbackground: #fff;\n\theight: auto;\n\tmin-height: auto;\n\tz-index: 99;\n}\n\n.kore-chat-window .card-template .card-body .card-title-block .more-button-info li {\n\tmargin: 0;\n}\n\n.kore-chat-window .card-template .card-body .card-title-block .more-button-info li .button_ {\n\tmargin: 5px 0;\n\tfloat: right;\n\tborder: 0;\n\tpadding: 7px 20px;\n\tbackground: #e7f1ff;\n\tborder-radius: 4px;\n\tcolor: #020203;\n\tfont-weight: normal;\n\tfont-size: 14px;\n\tline-height: 20px;\n\tcursor: pointer;\n\twidth: 100%;\n}\n\n.kore-chat-window .card-template .card-body .card-title-block .more-button-info .close_btn {\n\tcursor: pointer;\n\tborder: none;\n\toutline: none;\n\tposition: static !important;\n\t/* top: 5px; */\n\tright: 22px;\n\tbackground: #fff;\n\tborder-radius: 100%;\n\tpadding: 0;\n\twidth: 25px;\n\theight: 25px;\n\ttext-align: center;\n\tz-index: 2;\n\ttransition: 0.3s all ease;\n\tfloat: right;\n}\n\n.kore-chat-window .card-template .card-body .card-title-block .more-button-info .close_btn:hover {\n\tbackground: #DFE7F5;\n}\n\n\n/* .kore-chat-window .card-template .card-body .card-data{\n    padding: 20px 10px;\n} */\n\n.kore-chat-window .card-template .card-body .card-data-list {\n\t/* display: flex; */\n\talign-items: center;\n\tjustify-content: flex-start;\n}\n\n.kore-chat-window .card-template .card-body .card-data-list .card-block-text {\n\tpadding: 0 20px 0 0;\n\tflex: 1;\n}\n\n.kore-chat-window .card-template .card-body .card-data-list .card-block-text .title-text {\n\tfont-weight: 600;\n\tfont-size: 16px;\n\tline-height: 20px;\n\tcolor: #202124;\n}\n\n.kore-chat-window .card-template .card-body .card-data-list .card-block-text .title-desc {\n\tfont-weight: normal;\n\tfont-size: 13px;\n\tline-height: 20px;\n\tcolor: #9AA0A6;\n}\n\n.kore-chat-window .card-template .card-body .card-data-btn.btn-info .card-btn {\n\tbackground: #0D6EFD;\n\tborder: 1px solid #0D6EFD;\n\tcolor: #fff;\n}\n\n.kore-chat-window .card-template .card-body-info {\n\twidth: 5px;\n\theight: 100%;\n\tbackground: #0D6EFD;\n\tposition: absolute;\n\tborder-radius: 10px;\n}\n\n.kore-chat-window .card-template .card-body .card-title-block .card-text-action .card-action-data {\n\tcolor: #BDC1C6;\n\tfont-weight: normal;\n\tfont-size: 12px;\n\tline-height: 20px;\n}\n\n.kore-chat-window .card-template .card-body .card-title-block .card-text-action .icon {\n\tcursor: pointer;\n\tmargin-left: 5px;\n}\n\n\n/* card template card img overflowmenu info end */\n\n\n/* card template card simple data info start */\n\n.kore-chat-window .card-template.card-simple-data-info .card-body {\n\tborder: 1px solid #E4E5E7;\n\tbox-shadow: 0px 1px 2px #bdc1c6;\n\tborder-radius: 8px;\n}\n\n.kore-chat-window .card-template.card-simple-data-info .card-body .card-title-block {\n\tdisplay: flex;\n\talign-items: center;\n\tjustify-content: flex-start;\n\tpadding: 10px 10px;\n\tposition: relative;\n}\n\n.kore-chat-window .card-template.card-simple-data-info .card-body .card-title-block .card-block {\n\tborder-left: 5px solid #0d6efd;\n\tborder-radius: 4px;\n}\n\n\n/* card template card simple data info end */\n\n.kore-chat-window .card-template .card-body .card-data-btn .card-btn {\n\tborder-radius: 0px 0px 10px 10px;\n\twidth: 100%;\n\tpadding: 14px 0;\n\tfont-weight: 500;\n\tfont-size: 14px;\n\tline-height: 17px;\n\tcursor: pointer;\n}\n\n.kore-chat-window .card-template .card-body .card-title-block .card-block {\n\tpadding-left: 15px;\n\twidth: calc(100% - 29px);\n}\n\n.kore-chat-window .card-template .card-body .card-title-block .card-block .title-text {\n\tfont-weight: 600;\n\tfont-size: 16px;\n\tline-height: 20px;\n\tcolor: #202124;\n}\n\n.kore-chat-window .card-template .card-body .card-title-block .card-block .title-text.card-text-overflow {\n\toverflow: hidden;\n\ttext-overflow: ellipsis;\n\t/* width: 176px; */\n\t/* width: calc(100% - 190px); */\n\twhite-space: nowrap;\n\t/* padding-right: 10px; */\n\tpadding-right: 110px;\n}\n\n.kore-chat-window .card-template .card-body .card-title-block .card-block .title-desc {\n\tfont-weight: normal;\n\tfont-size: 13px;\n\tline-height: 20px;\n\tcolor: #9AA0A6;\n}\n\n.kore-chat-window .card-template .card-body .card-title-block .card-block-img {\n\twidth: 40px;\n\theight: 40px;\n\tflex-shrink: 0;\n}\n\n.kore-chat-window .card-template .card-body .card-title-block .card-block-img .icon-text {\n\twidth: 40px;\n\theight: 40px;\n\tvertical-align: middle;\n\tborder-radius: 8px;\n\tdisplay: flex;\n\talign-items: center;\n\tjustify-content: center;\n\tfont-weight: normal;\n\tfont-size: 12px;\n\tbackground: #0D6EFD;\n\tcolor: #FFFF;\n}\n\n.kore-chat-window .card-template .card-body .card-title-block .card-block-img.small {\n\twidth: 16px;\n\theight: 16px;\n}\n\n.kore-chat-window .card-template .card-body .card-title-block .card-block-img.small img {\n\twidth: 16px;\n\theight: 16px;\n}\n\n.kore-chat-window .card-template .card-body .card-title-block .card-block-img img {\n\tvertical-align: middle;\n}\n\n.kore-chat-window .card-template .card-body .card-title-block .card-block-img.circle-img img {\n\tborder-radius: 100%;\n}\n\n.kore-chat-window .card-template .card-body .card-title {\n\tfont-weight: 500;\n\tfont-size: 14px;\n\tline-height: 20px;\n\tpadding: 14px 14px;\n\toverflow: hidden;\n\ttext-overflow: ellipsis;\n\twhite-space: nowrap;\n}\n\n.kore-chat-window .card-template  .card-data {\n\tpadding: 10px 15px;\n}\n\n.kore-chat-window .card-template .card-data .card-data-list .card-text {\n\tcolor: #3C4043;\n\tfont-weight: 500;\n\tfont-size: 12px;\n\tline-height: 19px;\n\tdisplay: flex;\n\talign-items: flex-start;\n\tposition: relative;\n\tmargin: 5px 0;\n}\n\n.kore-chat-window .card-template .card-data .card-data-list .card-text.icon {\n\ttop: -16px;\n}\n\n.kore-chat-window .card-template .card-data .card-data-list .card-text .card-text-icon.if-icon-right .icon-img {\n\twidth: auto;\n\tposition: absolute;\n\tright: 4px;\n}\n\n.kore-chat-window .card-template .card-data .card-data-list .card-text .card-text-icon {\n\twidth: 25px;\n\tpadding: 5px 10px 0 0;\n}\n\n.kore-chat-window .card-template .card-data .card-data-list .card-text .card-text-icon img {\n\tvertical-align: middle;\n}\n\n.kore-chat-window .card-template .card-data .card-data-list .card-text .card-text-action {\n\tposition: absolute;\n\tright: 0;\n\ttransform: rotate(180deg);\n}\n\n.kore-chat-window .card-template .card-data .card-data-list.card-display-flex {\n\tdisplay: flex;\n}\n\n.kore-chat-window .koreLargePreviewContent.card-template-modal {\n\twidth: 350px !important;\n}\n\n\n/* card template css ends here */"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
